import axios from 'axios';

export default async function fetchConoscenzeInformatiche() {
  try {
    const URL = `${process.env.REACT_APP_API_URL}/api/conoscenze-informatiches?pagination[pageSize]=50&sort[0]=value`;
    const { data } = await axios.get(URL);
    return data?.data;
  } catch (e) {
    return [];
  }
}
